import { useGameStore } from '@campus/core';

/** « Coucou » reçus (double-clic sur un avatar) : dans la pile du haut à droite (App.tsx). */
export function WaveNotifications() {
  const waves = useGameStore((s) => s.waveNotifications);
  if (waves.length === 0) return null;
  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: 8, pointerEvents: 'none' }}>
      {waves.map((w) => (
        <div key={w.fromUserId} className="pl-hud" style={{ padding: '8px 14px', fontSize: 'var(--text-sm)', color: 'var(--color-text-primary)', gap: 8 }}>
          <span aria-hidden="true" style={{ fontSize: 18 }}>👋</span>
          <span><strong>{w.fromDisplayName}</strong> te fait signe</span>
        </div>
      ))}
    </div>
  );
}
